import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatState} from 'api/types'

export const masterKeysFound: CaseReducer<NinchatState> = (state) => state
